import { Centered, EmptyState, FlexColumn } from '@gorila-shared-ui/components';
import { Spinner } from 'baseui/spinner';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { GPS_TYPE_LABELS } from '../../../constants/device';
import { CONSUMPTION_TABLE_COLUMNS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';
import { getHistoricConsumption } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import { consumptionDateState, updateReportState } from '../../../storage/reports';
import { ConsumptionMedia } from '../../../types/reports';
import { StyledPaginatedTable } from '../../shared/StyledPaginatedTable';

export function ConsumptionReports() {
  const { css } = useStyles();
  const [records, setRecords] = useState<ConsumptionMedia[]>();
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const apiParams = useRecoilValue(apiParamsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const updateReport = useRecoilValue(updateReportState);
  const consumptionDate = useRecoilValue(consumptionDateState);

  useEffect(() => {
    if (page === 0) {
      setPage(1);
      return;
    }
    setLoading(true);
    const loadConsumptions = async () => {
      if (!apiParams?.clientId) return;
      const { error, historicConsumption, total } = await getHistoricConsumption(
        apiParams.clientId,
        page,
        consumptionDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId
      );
      if (!error && historicConsumption && total) {
        setRecords(historicConsumption);
        setTotalItems(total);
      } else if (error) {
        setRecords(undefined);
        setTotalItems(0);
      }
      setLoading(false);
    };
    loadConsumptions();

    return () => {
      setRecords(undefined);
    };
  }, [page, apiParams?.clientId, apiParams?.subClientId, isAllWorkspacesSelected, updateReport, consumptionDate]);

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      {!records?.length && loading && (
        <Centered>
          <Spinner />
        </Centered>
      )}
      {!records?.length && !loading && <EmptyState title="Todavía no cuenta con registro de consumos." />}
      {!!records?.length && (
        <StyledPaginatedTable
          columns={CONSUMPTION_TABLE_COLUMNS}
          data={records.map((record) => {
            return {
              id: record._id,
              items: [
                record.label,
                GPS_TYPE_LABELS[record.device.gpsType] || '-',
                Intl.NumberFormat().format(record.totalMbConsumed),
                Intl.NumberFormat().format(record.maxMb),
              ],
            };
          })}
          totalItems={totalItems}
          page={page}
          onPageChange={setPage}
          minTableWidthSize={480}
        />
      )}
    </FlexColumn>
  );
}
